<template>
	<div class="MapCard Card">
		<slot />
	</div>
</template>

<script>
	export default {

	};
</script>
